<template>
  <div>
    <component :is="currentLayout">
      <router-view />
      <!-- <Toasts /> -->
    </component>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Toasts from "@/components/Toasts.vue";

export default {
  name: 'App',
  components: {
    Toasts
  },

  computed: {
    ...mapState({
      layout: (state) => state.auth.componentLayout,
    }),
    currentLayout() {
      console.log('this.layout', this.layout);
      return this.layout;
    },
  },
}
</script>

<style>
</style>
